module.exports = new __parcel__URL__("CannotReadFileError.cc72fcf2.svg").toString();